import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-generic-report',
  templateUrl: './generic-report.component.html',
  styleUrls: ['./generic-report.component.scss']
})
export class GenericReportComponent implements OnInit {
  reportUrl = ""
  reportName!: string
  reportfilter!: string | null
  exportToPdf: string = "0"

  constructor(private activeRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activeRoute.params.subscribe(params => {
      this.reportName = params['reportName']
      this.exportToPdf = params['exportToPdf']
      this.reportfilter = localStorage.getItem("reportFilter")

      if (this.reportfilter !== null) {
        var filter = JSON.parse(this.reportfilter)
        if (this.reportName.includes("RptSymbolBalance")) {
          var today = new Date()
          var filterDate = new Date(filter.date)

          if (filterDate.getDate() == today.getDate()) {
            this.reportName = "RptClientSymbolBalance"
          }
        }

        this.reportUrl = this.reportName + "?=" + this.reportfilter
      }
    });
  }
}